import styled from "styled-components"

export const SearchContainer = styled.div`
  margin-bottom: 10px;
`

export const SearchHeader = styled.div`
  border: 1px solid #CCC;
  border-radius: 2px;
  cursor: pointer;
  padding: 8px 12px;

  &:hover {
    background: #F4F4F4;
  }
`